import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SellerIcon: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon sx={{ width: 85, height: 100, fill: 'none', ...sx }} viewBox="0 0 85 100" {...props}>
    <path
      d="M27.313 42.753v1.273a6.74 6.74 0 0 1-3.026 5.608h-.012q-.61.413-1.268.745a13.1 13.1 0 0 1-5.145 1.413l-1.3.089-1.89.124c-7.11.474-12.635 6.334-12.635 13.398v22.483m43.746-38.054q-.158-.099-.31-.198a6.73 6.73 0 0 1-3.026-5.608v-.618"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.583 55.673a17 17 0 0 1-5.215.803c-5.454 0-10.164-2.492-12.36-6.101M21.686 34.38c2.638 6.793 7.775 11.407 13.683 11.407s11.045-4.61 13.68-11.406"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.686 34.38c-1.542.459-3.367-1.07-4.08-3.418-.712-2.348-.039-4.623 1.5-5.084l2.416-.932.23-2.139a11.9 11.9 0 0 1 5.51-8.782 27.92 27.92 0 0 0 18.487 1.785l.058-.016a9.51 9.51 0 0 0 3.199 8.954l.22.186 2.395.944c1.543.457 2.212 2.736 1.5 5.084s-2.537 3.88-4.08 3.419"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.18 22.396a21 21 0 0 1 .478-5.088c.168-.764 2.99-12.738 13.37-15.295 5.54-1.366 11.914.28 15.844 4.416a14.6 14.6 0 0 1 2.31 3.23c.082.038.235.131.435.271 3.332 2.31 5.195 6.295 4.94 10.425a81 81 0 0 1-.144 1.91M16.908 69.26v18.626M61.33 73.977 40.627 62.32 61.33 50.67l20.708 11.65zm9.822-17.561L50.74 67.903m10.59 6.074.005 23.576-20.227-11.651-.481-23.581"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m61.334 97.554 20.222-11.652.48-23.581"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
